import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #f5c338;
  position: fixed;
  bottom: 100px;
  right: 0;
  z-index: 9999999;
  width: 400px;
  padding: 20px 30px;
  border-radius: 10px 0px 0px 10px;


  @media only screen and (max-width: 600px) {
    width: 90%;
    left: 50%;
    top: 30%;
    margin-left: -45%;
    bottom: unset;
    border-radius: 10px;
    box-shadow: 0px 0px 19px rgb(0,0,0,0.5);
}


  }

  & .hidden {
      display: none !important;
  }

  & .title-step {
    margin-bottom: 15px;
  }

  & .close-button {
    position: absolute;
    right: 30px;
    top: 20px;
    cursor: pointer;

    @media only screen and (max-width: 600px) {
      right: 15px;
      top: 15px;
    }
  }

  & .buttons {
      margin-top: 10px;

      & button {
          display: block;
          cursor: pointer;
          width: 49%;
          text-align: center;
          margin: 0 auto;
          float: left;
      }

      & .jump {
          color: rgba(0,0,0,0.3)
      }

      & .close {
        float: unset;
    }


  }
`;

